import {
  UDPATE_ACCOUNT_ACTIVATE_DATA,
  UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED,
  CHECK_ACTIVATION,
  CHECK_ACTIVATION_SUCCESSED,
  CHECK_ACTIVATION_FAILED,
  USER_ACTIVATION,
  USER_ACTIVATION_FAILED,
  USER_ACTIVATION_SUCCESSED
} from '../actions/actionTypes'

const initialState = {
  data: { question1: null, question2: null, question3: null, answer1: null, answer2: null, answer3: null, refnum: null, firstname: null, lastname: null, dob: null, ssn: null, password: null, confirmpassword: null, allowClaim: false },
  requesting_update: false,
  requesting_update_successful: false,
  requesting_check_activation: false,
  requesting_check_activation_successful: false,
  requesting_user_activation: false,
  requesting_user_activation_successful: false,
  message: null,
  infoError: null,
  loading_message: "Update account activate data..."
}

function accountActivateReducers(state = initialState, action) {
  switch (action.type) {
    case UDPATE_ACCOUNT_ACTIVATE_DATA:
      return Object.assign({}, {
        requesting_update: true,
        requesting_update_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        infoError: null,
        loading_message: "Update account activate data..."
      })
    case UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED:
      return Object.assign({}, {
        requesting_update: false,
        requesting_update_successful: true,
        data: Object.assign({}, action.data),
        message: null,
        infoError: null,
        loading_message: state.loading_message
      })

    case CHECK_ACTIVATION:
      return Object.assign({}, {
        requesting_check_activation: false,
        requesting_check_activation_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        infoError: null,
        loading_message: "Check account activation status..."
      })
    case CHECK_ACTIVATION_SUCCESSED:
      return Object.assign({}, {
        requesting_check_activation: false,
        requesting_check_activation_successful: true,
        data: Object.assign({}, state.data, action.data),
        message: null,
        infoError: null,
        loading_message: state.loading_message
      })
    case CHECK_ACTIVATION_FAILED:
      return Object.assign({}, {
        requesting_check_activation: false,
        requesting_check_activation_successful: false,
        data: Object.assign({}, state.data, action.data),
        message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
        infoError: action.infoError || null,
        loading_message: state.loading_message
      })
    //User activation
    case USER_ACTIVATION:
      return Object.assign({}, {
        requesting_user_activation: false,
        requesting_user_activation_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        infoError: null,
        loading_message: "Activating user account..."
      })
    case USER_ACTIVATION_SUCCESSED:
      return Object.assign({}, {
        requesting_user_activation: false,
        requesting_user_activation_successful: true,
        data: Object.assign({}, state.data, action.data),
        message: null,
        infoError: null,
        loading_message: state.loading_message
      })
    case USER_ACTIVATION_FAILED:
      return Object.assign({}, {
        requesting_user_activation: false,
        requesting_user_activation_successful: false,
        data: Object.assign({}, state.data, action.data),
        message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
        infoError: action.infoError || null,
        loading_message: state.loading_message
      })
    default:
      return state
  }
}

export default accountActivateReducers;
